// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../CrossD.Portal.Vue/ClientApp/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../CrossD.Portal.Vue/ClientApp/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-0f4aa8b7] .tab-pane{margin:0!important}[data-v-0f4aa8b7] .person-manager-filter{margin-bottom:.25rem}[data-v-0f4aa8b7] .person-manager-filter ul{margin-bottom:0}.person-tab--header[data-v-0f4aa8b7]{padding:.75rem;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
